import { Action } from '@ngrx/store';
import { Lookup } from '../../../../shared/models';
import * as viewModels from '../../view/view-models';

export const LOAD = '[RM Region Collection] Load';
export const LOAD_SUCCESS = '[RM Region Collection] Load Success';
export const LOAD_FAIL = '[RM Region Collection] Load Fail';

export class LoadPayload {
  constructor(public lookup: Lookup) {}
}

export class LoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: LoadPayload) {}
}

export class LoadSuccessPayload {
  constructor(public items: Array<viewModels.ListItem>, public total: number) {}
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction;

